import { LinkedFirestoreOfflineDocument } from "@/core/modules/firestore/objects/LinkedFirestoreOfflineDocument";
import { LinkedNorm } from "@/features/modules/norm/objects/LinkedNorm";
import { Risk } from "./Risk";

import { NumberWithDefaultField, ObjectField, StringField } from "@/core/fields";

export class LinkedRisk extends LinkedFirestoreOfflineDocument {
  public norm: LinkedNorm | undefined = undefined;
  public section: string | undefined = undefined;
  public name: string | undefined = undefined;
  public text: string | undefined = undefined;
  public order = 999;

  public constructor(firestoreData?: Record<string, unknown>) {
    super();
    if (firestoreData !== undefined) this.fromFirestore(firestoreData);
  }

  public static createFromRisk(risk: Risk): LinkedRisk {
    const linkedRisk: LinkedRisk = new LinkedRisk();
    linkedRisk.id = risk.id;
    linkedRisk.norm = risk.norm;
    linkedRisk.section = risk.section;
    linkedRisk.name = risk.name;

    return linkedRisk;
  }

  public fromFirestore(data: Record<string, unknown>): LinkedRisk {
    super.fromFirestore(data);

    this.norm = ObjectField.fromFirestore<LinkedNorm>(data.norm, (value) => new LinkedNorm(value));
    this.section = StringField.fromFirestore(data.section);
    this.name = StringField.fromFirestore(data.name);
    this.text = StringField.fromFirestore(data.text);
    this.order = NumberWithDefaultField.fromFirestore(data.order, 999);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.norm = ObjectField.toFirestore<LinkedNorm>(this.norm, (value) => value.toFirestore());
    firestoreData.section = StringField.toFirestore(this.section);
    firestoreData.name = StringField.toFirestore(this.name);
    firestoreData.text = StringField.toFirestore(this.text);
    firestoreData.order = NumberWithDefaultField.toFirestore(this.order, 999);

    return firestoreData;
  }

  public fromOfflineCache(data: Record<string, unknown>): LinkedRisk {
    super.fromOfflineCache(data);

    this.norm = ObjectField.fromOfflineCache<LinkedNorm>(data.norm, (value) => {
      const linkedNorm: LinkedNorm = new LinkedNorm();
      return linkedNorm.fromOfflineCache(value);
    });
    this.section = StringField.fromOfflineCache(data.section);
    this.name = StringField.fromOfflineCache(data.name);
    this.text = StringField.fromOfflineCache(data.text);
    this.order = NumberWithDefaultField.fromOfflineCache(data.order, 999);

    return this;
  }

  public toOfflineCache(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toOfflineCache();

    firestoreData.norm = ObjectField.toOfflineCache<LinkedNorm>(this.norm, (value) => value.toOfflineCache());
    firestoreData.section = StringField.toOfflineCache(this.section);
    firestoreData.name = StringField.toOfflineCache(this.name);
    firestoreData.text = StringField.toOfflineCache(this.text);
    firestoreData.order = NumberWithDefaultField.toOfflineCache(this.order, 999);

    return firestoreData;
  }
}
